import MediaQueries from "@/libs/media-queries";
import screens from "@/config/screens.json";

export const media = new MediaQueries( screens );
export default { media };

